
import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Leaderbord.css";
import Overlay from "../../components/Overlay";
import {
  subadminAccessChange,
} from "../../utils/functions";
import { IoIosCalendar } from "react-icons/io";
import { RiBarChartHorizontalLine } from "react-icons/ri";
// Mui & material UI
import Stack from "@mui/material/Stack";
import SearchBar from "material-ui-search-bar";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from "@mui/material/PaginationItem";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";
import { RxCross2 } from "react-icons/rx";

import { TextField, Popover, Box } from "@mui/material";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

// icons
import { AiOutlineDownload } from "react-icons/ai";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import Star from "../../assets/images/star.png";
import First from "../../assets/images/first.png";
import Second from "../../assets/images/second.png";
import Third from "../../assets/images/third.png";
import verified from "../../assets/images/verified.png";
import Placeholder from "../../assets/images/placeholder.jpg";
import Fire from "../../assets/images/fair.png";

import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  SearchFilterContainer,
  DashHeading,
  Button,
  ProfileDetailForm,
  TopRankData,
} from "./leaderboardElement";
import NoResults from "../../components/NoResult";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 6px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "100vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",

    // border: "1px solid rgba(17, 153, 38, 0.20)",

    // Optional scrollbar customization
    '&::-webkit-scrollbar': {
      height: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#5088FB',     // Scrollbar color
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none",

  },
  textMiddle: {
    padding: "0.3rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none",


  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const Leaderboard = ({ setUsers, userData, user }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const paymentManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "Leader board"
  )?.permissions || {};


  const canView = !!paymentManagementPermissions.view;
  const canAdd = !!paymentManagementPermissions.add;
  const canEdit = !!paymentManagementPermissions.edit;
  const canDelete = !!paymentManagementPermissions.delete;
  const canBlockUnblock = !!paymentManagementPermissions.blockUnblock;
  const canDownload = !!paymentManagementPermissions.download;

  const gigManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "Gigs Management"
  )?.permissions || {};

  const isSubAdminData = adminData?.userType === "subAdmin";

  // Check if view permissions in User Management are false
  const hasNoGigManagementPermissions = gigManagementPermissions &&
    !gigManagementPermissions.view


  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [isVisible, setIsVisible] = useState(true); // Initial state
  const [excelData, setExcelData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);





  const [tabSwitch, setTabSwitch] = useState(
    localStorage.getItem("filterTypeBookingData") || "host"
  ); // Default to ongoing

  const handleServiceTypeChangeData = (type) => {
    setTabSwitch(type);
    localStorage.setItem("filterTypeBookingData", type); // Save the active tab to localStorage
  };




  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel(); // your custom logic
    setPage(newPage); // this will trigger useEffect
  };

  const [selectedTypeOption, setSelectedTypeOption] = useState(null); // For service type filtering
  const [firstRankData, setFirstRankData] = useState(); // For store all category
  const [secondRankData, setSecondRankData] = useState();
  const [thirdRankData, setThirdRankData] = useState();
  const [isFilterApplied, setIsFilterApplied] = useState(false);


  const [allTableData, setAllTableData] = useState([]); // 4th onwards

  const [searchQuery, setSearchQuery] = useState("");



  const [selectedGigStatusOption, setSelectedGigStatusOption] = useState(null); // For Booking status filtering


  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };
  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;


  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };




  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };



  // This is for particular tab switch come from dashboard
  useEffect(() => {
    if (location?.state?.dashboardTab === "1" || location?.state?.dashboardTab === "2") {
      setTabSwitch(location.state.dashboardTab);
    }
  }, [location?.state?.dashboardTab]);



  // For Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  function myDeb(call, d = 1000) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        call(...args);
      }, d);
    };
  }

  // const SearchAccountManagement = myDeb((search) => {
  //   setSearchTerm(search);
  //   setPage(1); // Reset to the first page on search
  // });

  // const cancelSearch = () => {
  //   setSearchTerm("");
  //   setPage(1); // Reset to the first page when search is canceled
  // };

  const SearchAccountManagement = (value) => {
    setSearchQuery(value);

    if (value.trim() === "") {
      setTableData(allTableData); // reset if empty
    } else {
      const filtered = allTableData.filter((item) =>
        item?.userName?.toLowerCase().includes(value.toLowerCase()) // ✅ correct field
      );
      console.log("Filtered:", filtered);
      setTableData(filtered);
    }
  };

  // ✅ Cancel search
  const cancelSearch = () => {
    setSearchQuery("");
    setTableData(allTableData);
  };



  // Get Booking Management Data
  useEffect(() => {
    getLeaderBoard(page);
    getExcelData()
      .then((res) => res.json())
      .then((data) => setExcelData(data))
      .catch((error) => console.error("Error fetching data:", error));

  }, [page, rowsPerPage, searchTerm, tabSwitch]);
  //  const { data } = await axios.post(`/private/getTopStreakersInBoardForAdmin?search=${searchTerm}`,

  // const getLeaderBoard = async (currentPage, dateParam) => {
  //   setIsLoading(true);
  //   setTotalDocs(0);



  //   try {
  //     const { data } = await axios.post(`/private/getTopStreakersInBoardForAdmin`,
  //       {
  //         date: dateParam || selectedDate
  //       }
  //     );
  //     if (page == 1) {
  //       setFirstRankData(data?.data[0]);
  //       setSecondRankData(data?.data[1]);
  //       setThirdRankData(data?.data[2]);
  //     }
  //     setTotalDocs(data?.data);

  //     if (page === 1) {
  //       setTableData(data?.data?.slice(3));
  //     } else {
  //       setTableData(data?.data);
  //     }


  //   } catch (error) {
  //     if (error?.response?.status === 419) {
  //       localStorage.clear();
  //       Cookies.remove("showProfileSidebar");
  //       setUsers("");

  //       toast.error(`${error.response.data?.message}`, {
  //         position: "top-right",
  //       });
  //       navigate("/");
  //     } else if (error?.response?.status === 901) {
  //       subadminAccessChange(navigate);
  //       toast.error(`${error.response.data?.message}`, {
  //         position: "top-right",
  //       });
  //     } else {
  //       console.log("error", error?.response);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


  const getLeaderBoard = async (currentPage, dateParam) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getTopStreakersInBoardForAdmin`, {
        date: dateParam || selectedDate
      });
      console.log("getTopStreakersInBoardForAdmin", data)

      if (data?.data && data.data.length > 0) {
        // Agar data mila
        setFirstRankData(data.data[0] || null);
        setSecondRankData(data.data[1] || null);
        setThirdRankData(data.data[2] || null);

        const restData = data.data.slice(3);
        setAllTableData(restData);
        setTableData(restData);
        setTotalDocs(restData.length);
      } else {
        // Agar data empty ya null hai
        setFirstRankData(null);
        setSecondRankData(null);
        setThirdRankData(null);
        setAllTableData([]);
        setTableData([]);
        setTotalDocs(0);
      }

    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");
        toast.error(`${error.response.data?.message}`, { position: "top-right" });
        navigate("/");
      } else if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, { position: "top-right" });
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };







  const handleDownload = () => {
    // Format keys: convert camelCase to space-separated & capitalize, handle _id
    const formatKey = (key) => {
      if (key === '_id') return 'User Id';
      return key
        .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    };

    // Format data with formatted headers
    const formattedData = excelData.map(item => {
      const newItem = {};
      Object.entries(item).forEach(([key, value]) => {
        newItem[formatKey(key)] = value;
      });
      return newItem;
    });

    // Create worksheet from formatted data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Auto-calculate column widths
    const keys = Object.keys(formattedData[0] || {});
    const colWidths = keys.map(key => {
      const maxLength = Math.max(
        key.length,
        ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
      );
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = colWidths;

    // Bold header row (row 0)
    keys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true }
        };
      }
    });

    // Create workbook and append sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "table_data.xlsx");
  };



  const getExcelData = async (dateParam) => {

    try {
      const { data } = await axios.post(`/private/getTopStreakersInBoardExcelData`,
        {
          date: dateParam || selectedDate
        }
      );

      setExcelData(data?.data);
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  const [tempSelectedDate, setTempSelectedDate] = useState(null); // Temporary selected date

  // revenue Graph
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];


  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();

  // Allowed range: current date → previous 2 months
  const minDate = new Date(currentYear, currentMonth - 2, 1);
  const maxDate = today;

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedDate, setSelectedDate] = useState(today);

  // Generate days of selected month
  const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(selectedYear, selectedMonth, 1).getDay();

  const days = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(null); // empty slots before 1st day
  }
  for (let d = 1; d <= daysInMonth; d++) {
    days.push(new Date(selectedYear, selectedMonth, d));
  }

  // check if date is in allowed range
  const isDateSelectable = (date) => {
    if (!date) return false;
    return date >= minDate && date <= maxDate;
  };









  return (
    <>
      <DashboardContainer>
        <DashboardWrapper >
          <ProfileDetailForm>
            <DashboardHeading >
              <div className="common-heading">Leader Board</div>
            </DashboardHeading>

            <SearchFilterContainer>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <div>
                  {/* <SearchBar
                    style={{
                      minWidth: "23rem",
                      height: "40px",
                      borderRadius: "20px",
                      backgroundColor: "#F8F9FB",
                      color: "#212121",
                      fontStyle: "Italic",
                      fontWeight: 300,
                      fontSize: "15px",
                      fontFamily: "Roboto",
                    }}
                    className={"heightfix"}
                    onChange={(e) => {
                      SearchAccountManagement(e);
                    }}
                    onCancelSearch={cancelSearch}
                    placeholder="Search User Name...."
                    inputProps={{ maxLength: 30 }}
                  /> */}
                  <SearchBar
                    style={{
                      minWidth: "23rem",
                      height: "40px",
                      borderRadius: "20px",
                      backgroundColor: "#F8F9FB",
                      color: "#212121",
                      fontStyle: "Italic",
                      fontWeight: 300,
                      fontSize: "15px",
                      fontFamily: "Roboto",
                    }}
                    className={"heightfix"}
                    value={searchQuery}
                    onChange={SearchAccountManagement}
                    onCancelSearch={cancelSearch}
                    placeholder="Search User Name...."
                    inputProps={{ maxLength: 30 }}
                  />
                </div>



                <div className="dateFilter">
                  <div className="datefiltertext"><IoIosCalendar style={{ fontSize: "1.5rem" }} /> <span>{selectedDate ? selectedDate.toDateString() : "No filter applied"}</span></div>

                  <div
                    className="dateFilterDateselect"
                    onClick={(e) => {
                      if (isFilterApplied) {
                        // CLEAR FILTER -> current date ka data dikhao
                        const today = new Date();
                        const formattedToday = new Date(
                          today.getTime() - today.getTimezoneOffset() * 60000
                        ).toISOString();

                        setSelectedDate(today);
                        setTempSelectedDate(today);
                        setIsFilterApplied(false);

                        getLeaderBoard(1, formattedToday);
                      } else {
                        handleFilterClick(e);
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      fontWeight: "500",
                      color: isFilterApplied ? "#DD3300" : "#5088FB"
                    }}
                  >
                    {isFilterApplied ? (
                      <>
                        <RxCross2 style={{ fontSize: "1.5rem" }} /> Clear Filter
                      </>
                    ) : (
                      <>
                        <RiBarChartHorizontalLine /> Filters
                      </>
                    )}
                  </div>

                </div>
                <div>
                  {!(!canDownload && adminData?.userType === "subAdmin") && (
                    <Button
                      type="button"
                      style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontFamily: "Inter", fontSize: "14px", fontWeight: "400" }}
                      onClick={handleDownload}
                    >
                      Export as xlsx <AiOutlineDownload style={{ fontSize: "1.2rem" }} />
                    </Button>
                  )}
                </div>
              </div>

            </SearchFilterContainer>


            <TopRankData>
              <div className="mainRank">
                <div className="TopMainRank">
                  <div className="rankData">
                    <div><img src={First} /></div>
                    <div className="rankDataNumber">1st</div>
                  </div>
                  <div className="imgrankData">
                    <img
                      src={firstRankData?.userDetails?.profileImage || Placeholder}
                      style={{ height: "42px", width: "42px", borderRadius: "50%" }}
                      alt="Profile"
                    />
                  </div>
                  <div className="rankNameData">
                    {firstRankData && (
                      <>
                        {firstRankData.userDetails?.userName}<img src={verified} />
                      </>
                    )}
                  </div>
                </div>
                <div className="textBottomData">
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{firstRankData?.count ? firstRankData.count : "0"}</div>
                    <div className="textNameLeader">
                      {tabSwitch == "host" && (
                        <>
                          Gig Hosted
                        </>
                      )}
                      {tabSwitch == "worker" && (
                        <>
                          Gig Completed
                        </>
                      )}
                    </div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{firstRankData?.streakCount ? firstRankData.streakCount : "0"}</div>
                    <div className="textNameLeader">Streak</div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">
                      {/* {firstRankData?.averageRating
                      ? Number(firstRankData.averageRating).toFixed(1).replace(/\.0$/, "")
                      : "0"}<img src={Star} /> */}
                      {
                        firstRankData?.averageRating
                          ? (Math.floor(Number(firstRankData.averageRating) * 10) / 10)
                          : "0"
                      } <img src={Star} />
                    </div>
                    <div className="textNameLeader">Ratings</div>
                  </div>
                </div>
                <div style={{ padding: "0rem 1rem" }}>
                  <div className="profileDataLeader"
                    onClick={() => navigate(`//userDetails/${firstRankData._id}`,
                      { state: { from: "leaderboardManagement" } })}
                  >
                    Profile
                  </div>
                </div>



              </div>
              <div className="mainRank">
                <div className="TopMainRank">
                  <div className="rankData">
                    <div><img src={Second} /></div>
                    <div className="rankDataNumber">2nd</div>
                  </div>
                  <div className="imgrankData">
                    <img
                      src={secondRankData?.userDetails?.profileImage || Placeholder}
                      style={{ height: "42px", width: "42px", borderRadius: "50%" }}
                      alt="Profile"
                    />
                  </div>
                  <div className="rankNameData">
                    {secondRankData && (
                      <>
                        {secondRankData.userDetails?.userName}<img src={verified} />
                      </>
                    )}
                  </div>
                </div>
                <div className="textBottomData">
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{secondRankData?.count ? secondRankData.count : "0"}</div>
                    <div className="textNameLeader">
                      {tabSwitch == "host" && (
                        <>
                          Gig Hosted
                        </>
                      )}
                      {tabSwitch == "worker" && (
                        <>
                          Gig Completed
                        </>
                      )}
                    </div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{secondRankData?.streakCount ? secondRankData.streakCount : "0"}</div>
                    <div className="textNameLeader">Streak</div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">
                      {/* {secondRankData?.averageRating
                        ? Number(secondRankData.averageRating).toFixed(1).replace(/\.0$/, "")
                        : "0"}<img src={Star} /> */}
                      {
                        secondRankData?.averageRating
                          ? (Math.floor(Number(secondRankData.averageRating) * 10) / 10)
                          : "0"
                      } <img src={Star} />
                    </div>
                    <div className="textNameLeader">Ratings</div>
                  </div>
                </div>
                <div style={{ padding: "0rem 1rem" }}>
                  <div className="profileDataLeader"
                    onClick={() => navigate(`/userDetails/${secondRankData._id}`,
                      { state: { from: "leaderboardManagement" } })}
                  >
                    Profile
                  </div>
                </div>


              </div>
              <div className="mainRank">
                <div className="TopMainRank">
                  <div className="rankData">
                    <div><img src={Third} /></div>
                    <div className="rankDataNumber">3rd</div>
                  </div>
                  <div className="imgrankData">
                    <img
                      src={thirdRankData?.userDetails?.profileImage || Placeholder}
                      style={{ height: "42px", width: "42px", borderRadius: "50%" }}
                      alt="Profile"
                    />
                  </div>
                  <div className="rankNameData">
                    {thirdRankData && (
                      <>
                        {thirdRankData.userDetails?.userName}<img src={verified} />
                      </>
                    )}
                  </div>
                </div>
                <div className="textBottomData">
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{thirdRankData?.count ? thirdRankData.count : "0"}</div>
                    <div className="textNameLeader">
                      {tabSwitch == "host" && (
                        <>
                          Gig Hosted
                        </>
                      )}
                      {tabSwitch == "worker" && (
                        <>
                          Gig Completed
                        </>
                      )}
                    </div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">{thirdRankData?.streakCount ? thirdRankData.streakCount : "0"}</div>
                    <div className="textNameLeader">Streak</div>
                  </div>
                  <div className="textBottomitems">
                    <div className="textNumberLeader">
                      {
                        thirdRankData?.averageRating
                          ? (Math.floor(Number(thirdRankData.averageRating) * 10) / 10)
                          : "0"
                      } <img src={Star} />
                    </div>
                    <div className="textNameLeader">Ratings</div>
                  </div>
                </div>
                <div style={{ padding: "0rem 1rem" }}>
                  <div className="profileDataLeader"
                    onClick={() => navigate(`/userDetails/${thirdRankData._id}`,
                      { state: { from: "leaderboardManagement" } })}
                  >
                    Profile
                  </div>
                </div>


              </div>
            </TopRankData>

            <TableContainer className={classes.tableMainContainer}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadingRow}>
                    <TableCell className={classes.tableHeadingCell} >
                      User Name
                    </TableCell>
                    <TableCell className={classes.tableHeadingCell}>
                      Rank
                    </TableCell>
                    <TableCell className={classes.tableHeadingCell} >
                      Streak
                    </TableCell>

                    <TableCell className={classes.tableHeadingCell}>
                      Gigs Hosted
                    </TableCell>

                    {/* {tabSwitch == "worker" && (
                      <TableCell className={classes.tableHeadingCell}>
                        Gigs Completed
                      </TableCell>
                    )} */}
                    <TableCell className={classes.tableHeadingCell}>
                      Average Ratings
                    </TableCell>
                  </TableRow>
                </TableHead>
                {tableData && tableData.length > 0 ? (
                  <>
                    <TableBody>
                      {tableData.map((user, index) => (
                        <TableRow
                          className={classes.tableBodyRow}
                          key={user._id}
                        >
                          <TableCell className={classes.textMiddle}>
                            <div
                              style={{
                                color: "#4D59FF",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => navigate(`/userDetails/${user._id}`,
                                { state: { from: "leaderboardManagement" } })}
                            >
                              {get(user, "userName", "---")}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {(() => {
                                const number = page === 1
                                  ? index + 4
                                  : index + 1 + rowsPerPage * (page - 1);

                                const suffix = (n) => {
                                  const j = n % 10,
                                    k = n % 100;
                                  if (k === 11 || k === 12 || k === 13) return `${n}th`;
                                  if (j === 1) return `${n}st`;
                                  if (j === 2) return `${n}nd`;
                                  if (j === 3) return `${n}rd`;
                                  return `${n}th`;
                                };

                                return suffix(number);
                              })()}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}>
                            <div className="container-Leader">
                              <img src={Fire} className="fire-img-Leader" />
                              <div className="center-text-Leader">{get(user, "streakCount", "N/A")}</div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div >
                              {get(user, "count", "N/A")}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "2px",
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#000000"
                              }}
                            >
                              {(Math.floor((get(user, "averageRating") || 0) * 10) / 10).toFixed(1)}
                              <img src={Star} />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          colSpan={13}
                          align="center"
                          style={{ padding: "2rem", border: "none" }}
                        >
                          <DashHeading
                            style={{ textAlign: "center", padding: "2rem" }}
                          >
                            <NoResults />
                          </DashHeading>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
            {/* <Stack spacing={2} className={classes.paginationContainer}>
              <Pagination
                count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                page={page}
                onChange={(event, value) => handleChangePage(event, value)} // Update page
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: HiMiniArrowLeft,
                      next: HiMiniArrowRight,
                    }}
                    {...item}
                  />
                )}
              />
            </Stack> */}
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer >



      {/* Filter Popover */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, width: "360px" }}>
          <div style={{ width: "320px", fontFamily: "Roboto, sans-serif" }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
              {/* Month dropdown */}
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                style={{
                  padding: "6px 0px",
                  borderRadius: "8px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "16px"
                }}
              >
                {months
                  .slice(
                    Math.max(0, new Date().getMonth() - 2), // previous 2 months start
                    new Date().getMonth() + 1               // current month tak include
                  )
                  .map((m, idx) => (
                    <option key={m} value={idx + Math.max(0, new Date().getMonth() - 2)}>
                      {m}
                    </option>
                  ))}
              </select>

              {/* Year dropdown */}
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                style={{
                  padding: "6px",
                  borderRadius: "8px",
                  border: "none",
                  fontWeight: "600",
                  fontSize: "16px"
                }}
              >
                {[currentYear,].map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>

            {/* Days grid */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              textAlign: "center",
              gap: "4px"
            }}>
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <div key={day} style={{ fontWeight: "600", fontSize: "14px", color: "#555" }}>{day}</div>
              ))}
              {days.map((dateObj, idx) => {
                const selectable = isDateSelectable(dateObj);
                const isToday =
                  dateObj &&
                  dateObj.getDate() === currentDate &&
                  dateObj.getMonth() === currentMonth &&
                  dateObj.getFullYear() === currentYear;

                return (
                  <div
                    key={idx}
                    onClick={() => selectable && setTempSelectedDate(dateObj)}
                    style={{
                      padding: "6px 0",
                      borderRadius: "6px",
                      backgroundColor:
                        dateObj &&
                          tempSelectedDate &&
                          dateObj.getTime() === tempSelectedDate.getTime()
                          ? "#4c82f7"
                          : "transparent",
                      color: !dateObj
                        ? "transparent"
                        : !selectable
                          ? "#ccc"
                          : isToday
                            ? "red"
                            : "#000",
                      cursor: selectable ? "pointer" : "not-allowed"
                    }}
                  >
                    {dateObj ? dateObj.getDate() : ""}
                  </div>
                );
              })}
            </div>

            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
              <Button
                onClick={() => {
                  setTempSelectedDate(null); // reset temp selection
                  handleClose();
                }}
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (tempSelectedDate) {
                    setSelectedDate(tempSelectedDate);

                    const formattedDate = new Date(
                      tempSelectedDate.getTime() - tempSelectedDate.getTimezoneOffset() * 60000
                    ).toISOString();

                    getLeaderBoard(1, formattedDate);

                    setIsFilterApplied(true); //  Apply ke baad "Clear Filter" dikhne lagega
                  }
                  handleClose();
                }}
                style={{
                  background: "#5088FB",
                  color: "#ffffff",
                  padding: "0px 15px"
                }}
              >
                Apply
              </Button>
            </Box>
          </div>
        </Box>
      </Popover>
      {/* 
      {`Selected: ${selectedDate.toDateString()}` */}

      {isLoading && <Overlay />
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboard);



